export default {
    props : {
        initial : {
            type : Object,
            default : () => ({}),
        },
    },
    data : () => ({
        params : {
            quantity : 1,
        },
    }),
    computed : {
        isFavorite () {
            return false;//!!~this.$root.favoriteProductIds.indexOf(+this.initial.id);
        },
        isInCart () {
            return !!(this.$store.state.cart.items || []).find(o => o.productId == this.initial.id);
        },
        productsData () {
            return {};//this.$store.state.productsData;
        },
        price () {
            if (this.initial.price) {
                return this.initial.price;
            }
            return null;
        },
        oldPrice () {
            if (this.initial.oldPrice) {
                return this.initial.oldPrice;
            }
            return null;
        },
        amount () {
            return this.initial.amount || 0;
        },
    },
    methods : {
        setCompare (isCompare = true) {
            fetch(`/ajax/item.php?item=${this.initial.id}&compare_item=Y&iblock_id=55`)
            .then(res => res.json())
            .then(res => {
                if (res.STATUS == 'OK') {
                    if (isCompare) {
                        this.$root.alert('Товар добавлен к сравнению');
                    }
                    else {
                        this.$root.alert('Товар удалён из сравнения');
                    }
                }
                this.$store.dispatch('loadInitData');
            });
        },
        setFavorite (isFavorite = true) {
            fetch(`/ajax/item.php?item=${this.initial.id}&wish_item=Y&iblockID=55`)
            .then(res => res.json())
            .then(res => {
                if (res.STATUS == 'OK') {
                    if (isFavorite) {
                        this.$root.alert('Товар добавлен в избранное');
                    }
                    else {
                        this.$root.alert('Товар удалён из избранного');
                    }
                }
                this.$store.dispatch('loadInitData');
            });
        },
        setQuantity(val)
        {
            this.params.quantity = val;
        },
        addToCart () {
            let data = new FormData;
            if (this.params.selectedOfferId) {
                data.append("products[0][id]", this.params.selectedOfferId);
            }
            else {
                data.append("products[0][id]", this.initial.id);
            }
            data.append("products[0][quantity]", this.params.quantity);
            fetch("/ajax/v1/cart/add/", {
                method : "POST",
                body   : data,
            })
            .then(res => res.json())
            .then((result) =>
            {
                if(result && result.error)
                {
                    console.error(result.error);
                }
                else
                {
                    this.$store.dispatch("loadCartData").then((res) => {
                        if (res.items) {
                            this.$root.alert('Товар добавлен в корзину');
                        }
                    });
                }

            }).catch(() =>
            {
                console.error("Непредвиденная ошибка");
            });
        },
    },
}
